import linegraph from '../../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../../components/Table.vue";
import IPagination from "../../../../../components/pagination.vue";
import { domainName } from "../../../../../utility/index"

export default {
    props: ["bindDriver"],
    data() {
        return {
            optionLine: {},
            lineLoading: false,
            isLine: true,
            optionPie: {},
            pieLoading: false,
            overLoad: '',
            speedOver: '',
            collision: '',
            leaveFence: '',
            outPosition: '',
            orgId: '',
            driverNum: '',
            height: '500',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columnsAll: [
                {
                    prop: "driverNum",
                    label: this.$t('DriverAnalysis.driverNum'),
                    align: "center",
                },
                {
                    prop: "name",
                    label: this.$t('DriverAnalysis.name'),
                    align: "center",
                },
                {
                    prop: "orgName",
                    label: this.$t('DriverAnalysis.orgName'),
                    align: "center",

                },
                {
                    prop: "overloadCount",
                    label: this.$t('DriverAnalysis.overloadCount'),
                    align: "center",

                },
                {
                    prop: "speedOverCount",
                    label: this.$t('DriverAnalysis.speedOverCount'),
                    align: "center",

                },
                {
                    prop: "outPositionCount",
                    label: this.$t('DriverAnalysis.outPositionCount'),
                    align: "center",

                },
                {
                    prop: "collisionCount",
                    label: this.$t('DriverAnalysis.collisionCount'),
                    align: "center",
                },
                {
                    prop: "leaveFenceCount",
                    label: this.$t('DriverAnalysis.leaveFenceCount'),
                    align: "center",
                }
            ],
            columnsOne: [
                {
                    prop: "carId",
                    label: this.$t('DriverAnalysis.carId'),
                    align: "center",
                },
                {
                    prop: "terminalId",
                    label: this.$t('DriverAnalysis.terminalId'),
                    align: "center",
                },
                {
                    prop: "driverNum",
                    label: this.$t('DriverAnalysis.driverNum'),
                    align: "center",
                },
                {
                    prop: "driverName",
                    label: this.$t('DriverAnalysis.name'),
                    align: "center",
                },
                {
                    prop: "orgName",
                    label: this.$t('DriverAnalysis.orgName'),
                    align: "center",

                },
                {
                    prop: "endTime",
                    label: this.$t('DriverAnalysis.violationTime'),
                    align: "center",

                },
                {
                    prop: "eventMessage",
                    label: this.$t('DriverAnalysis.eventMessage'),
                    align: "center",
                }
            ],
            columns: [],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1, 
            pageSize: 10,
            total: 1, 
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination
    },
    methods: {
        initQuery(type) {
            console.log(type)
            this.type = type
            this.pageSize = 10
            this.currentPage = 1
            if (type == 'one') {
                this.columns = this.columnsOne
                this.getOneMonthOrderList()
            } else {
                this.columns = this.columnsAll
                this.getMonthOrderList()
            }
        },
        getFaultPeriod() {
            this.lineLoading = true
            let dateArr = [];
            let overLoad = [];
            let speedOver = []; 
            let collision = [];
            let leaveFence = [];
            let outPosition = [];
            let param = {
                orgId: Number(this.orgId),
                driverNum: this.driverNum,
                selectType: 0
            }
            this.$store.dispatch("DriverAnalysis/GET_QUERYDRIVERCOUNTMISTAKEPERIOD", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        if (res.data.data.length > 0) {
                            this.isLine = true
                            res.data.data.map((item, index) => {
                                dateArr.push(item.updateTimeStr)
                                overLoad.push(item.overloadCount)
                                speedOver.push(item.speedOverCount)
                                collision.push(item.collisionCount)
                                leaveFence.push(item.leaveFenceCount)
                                outPosition.push(item.outPositionCount)
                                this.FaultLine(dateArr,overLoad,speedOver,collision,leaveFence,outPosition)
                            })
                        } else {
                            this.isLine = false
                        }
                    }
                }
                this.lineLoading = false
            }).catch(err => {
                this.lineLoading = false
            })
        },
        FaultLine(dateArr, overLoad, speedOver, collision, leaveFence, outPosition) {
            let option = {
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    left: 'center',
                    data: [this.$t('DriverAnalysis.overloadCount'), this.$t('DriverAnalysis.speedOverCount'), this.$t('DriverAnalysis.outPositionCount'), this.$t('DriverAnalysis.collisionCount'), this.$t('DriverAnalysis.leaveFenceCount')],
                    top: '10',
                    textStyle: {
                        color: '#fff'
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff',
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#fff',
                        }
                    },
                    splitLine: { show: false },
                    data: dateArr
                },
                grid: {
                    left: '1%',
                    right: '2%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: [{
                    type: 'value',
                    name: this.$t('DriverAnalysis.value'),
                    nameTextStyle: {
                        color: "white",
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['rgba(173,177,195,.1)'],
                            type: 'dashed'
                        }
                    },
                    axisLabel: {
                        formatter: '{value}',
                        color: '#fff'
                    }
                }],
                series: [
                    {
                        name: this.$t('DriverAnalysis.overloadCount'),
                        type: 'line',
                        smooth: true,
                        color: '#48e1f9',
                        data: overLoad
                    },
                    {
                        name: this.$t('DriverAnalysis.speedOverCount'),
                        type: 'line',
                        smooth: true,
                        color: '#409eff',
                        data: speedOver,
                    },
                    {
                        name: this.$t('DriverAnalysis.outPositionCount'),
                        type: 'line',
                        smooth: true,
                        color: '#8f70f7',
                        data: outPosition,
                    },
                    {
                        name: this.$t('DriverAnalysis.collisionCount'),
                        type: 'line',
                        smooth: true,
                        color: '#d860a1',
                        data: collision,
                    },
                    {
                        name: this.$t('DriverAnalysis.leaveFenceCount'),
                        type: 'line',
                        smooth: true,
                        color: '#fc5b62',
                        data: leaveFence,
                    }
                ]
            }
            this.optionLine = option
        },

        getFaultMonth() {
            this.pieLoading = true
            let param = {
                orgId: Number(this.orgId),
                driverNum: this.driverNum,
                selectType: 0
            }
            this.$store.dispatch("DriverAnalysis/GET_QUERYDRIVERCOUNTPERIODRATE", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.overLoad = res.data.data.overloadCount.indexOf('%') > -1 ? res.data.data.overloadCount.split('%')[0] : ""
                        this.speedOver = res.data.data.speedOverCount.indexOf('%') > -1 ? res.data.data.speedOverCount.split('%')[0] : ''
                        this.collision = res.data.data.collisionCount.indexOf('%') > -1 ? res.data.data.collisionCount.split('%')[0] : ''
                        this.leaveFence = res.data.data.leaveFenceCount.indexOf('%') > -1 ? res.data.data.leaveFenceCount.split('%')[0] : ''
                        this.outPosition = res.data.data.outPositionCount.indexOf('%') > -1 ? res.data.data.outPositionCount.split('%')[0] : ''
                        this.FaultPie(this.overLoad,this.speedOver,this.collision,this.leaveFence,this.outPosition)
                    }
                }
                this.pieLoading = false
            }).catch(err => {
                this.pieLoading = false
            })
        },
        FaultPie(overLoad,speedOver,collision,leaveFence,outPosition) {
            let option = {
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                legend: {
                    orient: 'vertical',
                    left: '5%',
                    top: 'center',
                    itemWidth: 10,   
                    itemHeight: 10,  
                    itemGap: 20,
                    textStyle: {
                        color: '#fff'
                    },
                    data: [this.$t('DriverAnalysis.overloadCount'), this.$t('DriverAnalysis.speedOverCount'), this.$t('DriverAnalysis.outPositionCount'), this.$t('DriverAnalysis.collisionCount'), this.$t('DriverAnalysis.leaveFenceCount')]
                },
                series: [
                    {
                        name: this.$t('common.number'),
                        type: 'pie',
                        radius: ['45%', '65%'],
                        center: ['60%', '50%'],
                        data: [
                            {value:overLoad, name:this.$t('DriverAnalysis.overloadCount')},
                            {value:speedOver, name:this.$t('DriverAnalysis.speedOverCount')},
                            {value:outPosition, name:this.$t('DriverAnalysis.outPositionCount')},
                            {value:collision, name:this.$t('DriverAnalysis.collisionCount')},
                            {value:leaveFence, name:this.$t('DriverAnalysis.leaveFenceCount')},
                        ],
                        label: {
                            color: '#fff'
                        },
                        color: ['#48e1f9','#409eff','#8f70f7','#d860a1','#fc5b62','#f69c70'],
                    }
                ]
            }
            this.optionPie = option
        },

        getMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectType: 0,
            };
            this.$store.dispatch('DriverAnalysis/GET_QUERYMISTAKEPAGEBYDRIVER', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        getOneMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectType: 0,
                driverNum: this.driverNum
            };
            this.$store.dispatch('DriverAnalysis/GET_QUERYMISTAKEPAGEBYDRIVER', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        downCar() {
            if (this.type == 'one') {
                console.log(111)
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/mistake/uploadMistakePageByDriver?orgId=${this.orgId}&selectType=${0}&driverNum=${this.bindDriver}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/mistake/uploadMistakePageByDriver?orgId=${this.orgId}&selectType=${0}&driverNum=${this.bindDriver}`
                        location.href = url
                    }
                }
            } else {
                console.log(222)
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/mistake/uploadMistakePageByDriver?orgId=${this.orgId}&selectType=${0}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/mistake/uploadMistakePageByDriver?orgId=${this.orgId}&selectType=${0}`
                        location.href = url
                    }
                }
            }
            
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            if (this.type == 'one') {
                this.columns = this.columnsOne
                this.getOneMonthOrderList()
            } else {
                this.columns = this.columnsAll
                this.getMonthOrderList()
            }
        },
    }
}
